var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.view,{tag:"component",attrs:{"profile":_vm.profile},on:{"update:profile":_vm.updateProfile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }